import React from 'react'
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";
import { replaceToggle, replaceTab } from '../../../../../utils/dynamicHeader'

export const replaceHdr = (title, currentTab, currentToggle) => {
    let replacement = replaceToggle(currentToggle, title)
    replacement = replaceTab(currentTab, replacement)
    return replacement
}

const Header = ({ figureData, currentToggle, slug, currentTab }) => {

    const location = useLocation();

    useEffect(() => {
      const hash = location.hash;
      if (hash) {
        const targetElement = document.getElementById(hash.replace('#', ''));
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'instant' });
        }
      }
    }, [location]);

    return (
        <>
            <div className="graph-header" id={slug} style={{ paddingTop: '2em' }}>
                <h2>
                    <div className="graph-header-figureNumber">{figureData.figureNumber}</div>
                    &nbsp;
                    <div className="graph-header-title">{replaceHdr(figureData.title, currentTab, currentToggle)}</div></h2>
            </div>
        </>
    )
}

export default Header